import Phaser from 'phaser';
import { COLORS, GAME_W, GAME_H, intToHex } from '../utils/constants';

export default class PreloadScene extends Phaser.Scene {
  constructor() {
    super({ key: 'PreloadScene' });
  }

  preload() {
    const progressBar = this.add.graphics();
    const progressBox = this.add.graphics();
    progressBox.fillStyle(COLORS.darkGray, 0.8);
    progressBox.fillRect(GAME_W / 2 - 160, GAME_H / 2 - 20, 320, 40);

    const loadingText = this.add.text(GAME_W / 2, GAME_H / 2 - 50, '加载中...', {
      fontFamily: 'Microsoft YaHei, sans-serif',
      fontSize: '18px',
      color: intToHex(COLORS.cyan),
    }).setOrigin(0.5);

    this.load.on('progress', (value: number) => {
      progressBar.clear();
      progressBar.fillStyle(COLORS.cyan, 1);
      progressBar.fillRect(GAME_W / 2 - 150, GAME_H / 2 - 10, 300 * value, 20);
    });

    this.load.on('complete', () => {
      progressBar.destroy();
      progressBox.destroy();
      loadingText.destroy();
    });

    // All textures are generated programmatically
    // Use Phaser timer instead of setTimeout
  }

  create() {
    this.time.delayedCall(600, () => {
      this.cameras.main.fadeOut(300, 0, 0, 30);
      this.time.delayedCall(300, () => {
        this.scene.start('TitleScene');
      });
    });
  }
}
